<button
  type="button"
  class="workspace-company-card"
  [class.workspace-company-card--active]="active()"
  (click)="onSelect()"
>
  <span
    class="workspace-company-card__logo"
    [class.workspace-company-card__logo--image]="!!logoUrl()"
    [style.background]="logoUrl() ? '#f8fafc' : brandColor()"
  >
    @if (logoUrl()) {
      <img [src]="logoUrl()" alt="" (error)="onLogoError()" />
    } @else {
      <span class="workspace-company-card__initials">{{ initials() }}</span>
    }
  </span>

  <span class="workspace-company-card__body">
    <span class="workspace-company-card__top">
      <span class="workspace-company-card__name">{{ company().name }}</span>
      @if (active()) {
        <span class="workspace-company-card__active-pill">
          {{ 'header.workspacePicker.active' | translate }}
        </span>
      }
    </span>

    <span class="workspace-company-card__meta">
      <span class="workspace-company-card__role">{{ roleKey() | translate }}</span>
      @if (slugLabel()) {
        <span class="workspace-company-card__dot" aria-hidden="true">·</span>
        <span class="workspace-company-card__slug">{{ slugLabel() }}</span>
      }
    </span>

    @if (showLocationsSoon()) {
      <span class="workspace-company-card__soon">
        {{ 'header.workspacePicker.locationsSoon' | translate }}
      </span>
    }
  </span>

  <span class="workspace-company-card__chevron" aria-hidden="true">
    <i-tabler name="chevron-right" class="flex text-lg!"></i-tabler>
  </span>
</button>
